import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4 10h15v4H4z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 18h19v2H2zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6H4v-4h15v4zM2 4h19v2H2z"
})), 'ViewDayTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewDayTwoTone.js
// module id = 7099
// module chunks = 2